
      // Load dev script in development (HMR) only when the backend does NOT inject the preamble.
      // Values come from meta tags (buyr-app-env, buyr-use-preamble) so replacement only happens in HTML attributes.
      const appEnv = document.querySelector('meta[name="buyr-app-env"]')?.getAttribute('content') ?? 'development'
      const shouldLoadDevScript = appEnv === 'development'

      if (shouldLoadDevScript) {
        const script = document.createElement('script')
        script.setAttribute('type', 'module')
        script.setAttribute('src', window.location.origin+'/dev_embed.js')
        document.getElementsByTagName('head')[0].append(script)
      }
    